import List from 'containers/ChainStores/List';
import Edit from 'containers/ChainStores/Edit';

export default { List, Edit };
